<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#FFFFFF"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9; height: 80px; padding-top: 10px; left: 0px;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center pl-0"
          :style="clipped ? 'padding-left: 6px;' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              @click="clipped = false"
              contain
              width="40"
              height="40"
              alt="Mitra Warung"  
              :src="require('@/assets/logo/favicon.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>


          <!-- <v-chip
            :color="set_color"
            style="min-width: 120px; height: 43px; border-radius: 50px; justify-content: center">
            <span
              class="body-2 white--text mx-2"
              style="font-weight: 600;">
              {{ user.unit_title }}
            </span>
          </v-chip> -->
          <v-row class="d-flex align-center justify-center d-sm-none">
            <v-col cols="12" class="text-center">
              <v-img
                :src="require('@/assets/logo/logo_small.jpeg')"
                max-width="100"
                contain
                class="mx-auto"
              ></v-img>
            </v-col>
          </v-row>

          <!-- TABLET & DESKTOP: logo + nama cabang -->
          <v-row class="d-none d-sm-flex align-center justify-center text-center">
            <!-- Logo -->
            <v-col cols="12" sm="auto" class="pr-0">
              <v-img
                :src="company.logo !== undefined && company.logo !== '' ? company.logo : require('@/assets/logo/logo_small.jpeg')"
                max-width="175"
                contain
                class="mx-auto"
              ></v-img>
            </v-col>

            <!-- Branch Name -->
            <v-col cols="12" sm="auto" class="pl-0">
              <div class="black--text font-weight-bold">
                {{ user.branch_name }}
              </div>
            </v-col>
          </v-row>


          <!-- <v-chip
            class="ma-4 white--text px-8 font-weight-medium"
            style="height: 43px; border-radius: 50px;"
            color="#1814f3"
          >
          <v-icon left>
            mdi-domain
          </v-icon>

            <span
              class="body-2 white--text ml-1"
              style="font-weight: 600;">
              {{ user.branch_name }}
            </span>
          </v-chip> -->

          
        </v-toolbar-title>

        <v-spacer/>

        <!-- <div
          class="mr-7"
          style="width: 225px;">
          <v-text-field
            class="no_box"
            outlined
            rounded
            placeholder="Search for something"

            prepend-inner-icon="mdi-magnify"

  
            hide-details
  
            v-model="search">
          </v-text-field>
        </div>


        <div
          class="mr-7">
          <v-btn
            color="#F5F7FA"
            elevation="0"
            width="50"
            height="50"
            to="/setting?menu=profile"
            class="white--text"
            fab
          >
            <v-img 
              width="25px"
              height="25px"
              contain
              alt="Mitra Warung"  
              :src="require('@/assets/icon/settings.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-btn>
        </div>

        <div
          class="mr-7">
          <v-btn
            color="#F5F7FA"
            elevation="0"
            width="50"
            height="50"
            class="white--text"
            fab
          >
            <v-img 
              width="25px"
              height="25px"
              contain
              alt="Mitra Warung"  
              :src="require('@/assets/icon/notification.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-btn>
        </div> -->

        <!-- <v-avatar 
          size="50"
          class="mr-6">
          <v-img 
            width="100%"
            height="100%"
            alt="Mitra Warung"  
            @click="toMenu(menu.right[1])"
            :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
            class="ma-auto">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  size="20"
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar> -->
        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              dense
              color="transparent"
              style="max-width: 400px;">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 50px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="40"
                  class="mr-3">
                  <v-img 
                    width="100%"
                    height="100%"
                    alt="kominfoklaten"  
                    :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 font-weight-bold">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        width="280"
        color="#FFFFFF"
        dark
        fixed
        app>
        <div
          class="d-flex align-center justify-center cursor-pointer pa-3 py-1"
          style="height: 81px; background: #FFFFFF; border-bottom: 1px solid #E6EFF5;">
          <div
            class="d-flex align-center">
            <div v-if="!clipped"
              class="d-flex align-center justify-end">
              <!-- <v-img
                contain
                width="160"
                height="40"
                alt="Mitra Warung"  
                :src="require('@/assets/logo/Logo.png')"
                class="">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img> -->
            </div>

            <!-- <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                large
                color="black">
                mdi-pan-left
              </v-icon>
            </v-btn> -->
          </div>
        </div>
        <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;" class="mt-0">
          <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="color-light-black">
                  Management
                </v-list-item-title>
              </v-list-item-content>
          </v-list-item>

          <div 
            v-for="(item, index) in menu.left"
            :key="index" 
            style="z-index: 50;">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent"
              :style="clipped ? 'padding: 0px 13px;' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-2">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="megavin"  
                  :src="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? item.icon_color : item.icon_color"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="fs-15"
                    :class="item.link === $route.fullPath ? 'color-dark-black' : 'color-light-black'"
                    :style="item.link === $route.fullPath ? `color: #333333;` : 'color: #757575'">
                  {{ item.title }}  
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="item.title !== 'Konfigurasi' && item.sub_menu.length > 0"
              v-model="item.active"
              :color="set_color"
              no-action
              :class="clipped ? 'clipped_header' : ''">
              <template v-slot:activator>
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-2"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item.link.split('/')[1] === $route.fullPath.split('/')[1] || item.active ? item.icon_color : item.icon_color"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="fs-15"
                    :class="item.active ? 'color-dark-black' : 'color-light-black'"
                    :style="item.active === $route.fullPath ? `color: #333333;` : 'color: #757575'">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                @click="restartFilter(); restartFilterOrder()"
                :to="item_sub.link"
                color="transparent">
                <v-list-item-content :style="item_sub.link.split('/')[1] === $route.fullPath.split('/')[1] && item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `background: #F6F6F6;` : ''" style="border-radius: 8px; padding-left: 12px; padding-right: 12px;">
                  <v-list-item-title
                    class="fs-12"
                    :style="item_sub.link.split('/')[1] === $route.fullPath.split('/')[1] && item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `color: #333333;` : 'color: #757575'">
                    {{ item_sub.title }}
                  </v-list-item-title>
                  <v-divider vertical
                    style="border-color: rgb(246 246 246); position: absolute; left: 35px; top: 0px; border-width: 1.2px;">
                  </v-divider>
                  <div
                    style="height: 12px;
                    width: 20px;
                    border-left: 1px solid rgb(246 246 246);
                    border-bottom: 1px solid rgb(246 246 246);
                    position: absolute;
                    border-radius: 0px 0px 0px 8px;
                    left: 35px;
                    border-width: 2px;
                    top: 8px;">

                  </div>
                  <!-- <v-divider 
                    style="border-color: rgb(246 246 246); position: absolute; right: 0px; top: 0px; border-width: 1.2px;">
                  </v-divider> -->
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <div
              v-if="item.title === 'Konfigurasi' && item.sub_menu.length > 0">
              <div
                class="body-1 black--text text-uppercase pa-4"
                style="font-weight: 600;">
                <span v-if="clipped">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </span>
                
                <span v-else>
                  {{ item.title }}
                </span>
              </div>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent"
                :style="clipped ? 'padding: 0px 13px;' : ''">
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '' : 'box_false'"
                  :color="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? set_color_rgb_down : '#FFFFFF'"
                  :style="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item_sub.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? '' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color}; font-weight: 600;` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>

          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        search: '',
        menu: {
          right: [
            {
              title: 'Profile',
              type: 'profile',
              link: '/setting?menu=profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        },
        process: {
          load: false
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      counter () {
        return this.$store.state.counter
      }
    },
    created () {
      
    },
    async mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      // Fetch menu from API based on user role and access rights
      await this.fetchMenu()
      
      // Sort menu agar Dashboard (id 122) selalu di paling atas
      this.sortMenuDashboardFirst()

      this.fetchConfig()
      TokenService.saveColor('#718EBF')

      this.$store.commit("setColor", '#718EBF')
    },
    methods: {
      getMenuDefault () {
        return [
          {
            id: 122,
            title: 'Dashboard',
            icon: require('@/assets/icon/dashboard.png'),
            icon_color: require('@/assets/icon/dashboard.png'),
            link: '/dashboard',
            active: false,
            sub_menu: [],
          },
          { 
            id: 1,
            title: 'User',
            icon: require('@/assets/icon/profile.png'),
            icon_color: require('@/assets/icon/profile-color.png'),
            link: '/user',
            active: false,
            sub_menu: [
              {
                id: 2,
                title: 'Staff',
                link: '/user/staff',
                icon: require('@/assets/icon/profile.png'),
                icon_color: require('@/assets/icon/profile-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 3,
                title: 'Supplier',
                link: '/user/supplier',
                icon: require('@/assets/icon/profile.png'),
                icon_color: require('@/assets/icon/profile-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 4,
                title: 'Kategori Staff',
                link: '/user/category',
                icon: require('@/assets/icon/profile.png'),
                icon_color: require('@/assets/icon/profile-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 10,
            title: 'Sales',
            icon: require('@/assets/icon/sales-manager.png'),
            icon_color: require('@/assets/icon/sales-manager-color.png'),
            link: '/sales',
            active: false,
            sub_menu: [
              {
                id: 11,
                title: 'sales',
                link: '/sales/staff',
                icon: require('@/assets/icon/sales-manager.png'),
                icon_color: require('@/assets/icon/sales-manager-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 12,
                title: 'Kode Sales (Area Sales)',
                link: '/sales/code',
                icon: require('@/assets/icon/sales-manager.png'),
                icon_color: require('@/assets/icon/sales-manager-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 6,
            title: 'Customer',
            icon: require('@/assets/icon/target.png'),
            icon_color: require('@/assets/icon/target-color.png'),
            link: '/customer/data',
            active: false,
            sub_menu: [
              {
                id: 700,
                title: 'Tambah Customer',
                link: '/customer/add',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 7,
                title: 'Customer Saya',
                link: '/customer/data',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 59,
                title: 'Pengajuan Customer',
                link: '/customer/proses',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 61,
                title: 'Histori Rejected',
                link: '/customer/reject',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 81,
                title: 'Customer Blacklist',
                link: '/customer/blacklist',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 8,
                title: 'Perubahan Plafon',
                link: '/customer/plafon',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 9,
                title: 'Perubahan Customer',
                link: '/customer/perubahan',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 84,
                title: 'Customer Mapping',
                link: '/customer/mapping',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 85,
            title: 'Live Tracking',
            icon: require('@/assets/icon/shipment-tracking.png'),
            icon_color: require('@/assets/icon/shipment-tracking-color.png'),
            link: '/tracking',
            active: false,
            sub_menu: [
              {
                id: 86,
                title: 'live Sales',
                link: '/tracking/sales',
                icon: require('@/assets/icon/shipment-tracking.png'),
                icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 87,
                title: '⁠Live Driver',
                link: '/tracking/driver',
                icon: require('@/assets/icon/shipment-tracking.png'),
                icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 14,
            title: 'Produk',
            icon: require('@/assets/icon/dairy-products.png'),
            icon_color: require('@/assets/icon/dairy-products-color.png'),
            link: '/product',
            active: false,
            sub_menu: [
              {
                id: 15,
                title: 'Data Produk',
                link: '/product/data',
                icon: require('@/assets/icon/dairy-products.png'),
                icon_color: require('@/assets/icon/dairy-products-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 16,
                title: 'Varian Produk',
                link: '/product/varian',
                icon: require('@/assets/icon/dairy-products.png'),
                icon_color: require('@/assets/icon/dairy-products-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 17,
                title: 'Kategori Produk',
                link: '/product/category_product',
                icon: require('@/assets/icon/dairy-products.png'),
                icon_color: require('@/assets/icon/dairy-products-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 18,
                title: 'Group Produk',
                link: '/product/group',
                icon: require('@/assets/icon/dairy-products.png'),
                icon_color: require('@/assets/icon/dairy-products-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 41,
            title: 'Stok',
            icon: require('@/assets/icon/in-stock.png'),
            icon_color: require('@/assets/icon/in-stock-color.png'),
            link: '/stok',
            active: false,
            sub_menu: [
              {
                id: 42,
                title: 'Stok',
                link: '/stok/data',
                icon: require('@/assets/icon/in-stock.png'),
                icon_color: require('@/assets/icon/in-stock-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 90,
                title: 'Penyesuaian Stok',
                link: '/stok/penyesuaian-stock',
                icon: require('@/assets/icon/in-stock.png'),
                icon_color: require('@/assets/icon/in-stock-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 22,
            title: 'Kelola Visit',
            icon: require('@/assets/icon/visitor.png'),
            icon_color: require('@/assets/icon/visitor-color.png'),
            link: '/visit',
            active: false,
            sub_menu: [
              {
                id: 78,
                title: 'Laporan Visit',
                link: '/visit/laporan',
                icon: require('@/assets/icon/visitor.png'),
                icon_color: require('@/assets/icon/visitor-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 24,
                title: 'Buat Jadwal Visit',
                link: '/visit/jadwal',
                icon: require('@/assets/icon/visitor.png'),
                icon_color: require('@/assets/icon/visitor-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 83,
                title: 'Pergantian Jadwal',
                link: '/visit/jadwal-change',
                icon: require('@/assets/icon/visitor.png'),
                icon_color: require('@/assets/icon/visitor-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 111,
            title: 'Laporan Visit Driver',
            icon: require('@/assets/icon/route.png'),
            icon_color: require('@/assets/icon/route.png'),
            link: '/laporan-visit-driver',
            active: false,
            sub_menu: [],
          },
          {
            id: 25,
            title: 'Presensi',
            icon: require('@/assets/icon/absent.png'),
            icon_color: require('@/assets/icon/absent-color.png'),
            link: '/presensi',
            active: false,
            sub_menu: [
              {
                id: 26,
                title: 'Laporan Presensi',
                link: '/presensi/data',
                icon: require('@/assets/icon/absent.png'),
                icon_color: require('@/assets/icon/absent-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 27,
                title: 'Laporan Ijin',
                link: '/presensi/ijin',
                icon: require('@/assets/icon/absent.png'),
                icon_color: require('@/assets/icon/absent-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 28,
            title: 'Pembelian',
            icon: require('@/assets/icon/cash-on-delivery.png'),
            icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
            link: '/pengajuan',
            active: false,
            sub_menu: [
              {
                id: 29,
                title: 'Permintaan Stok',
                link: '/pengajuan/pembelian-warehouse',
                icon: require('@/assets/icon/cash-on-delivery.png'),
                icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 30,
                title: 'Permintaan GM',
                link: '/pengajuan/pembelian-general-manager',
                icon: require('@/assets/icon/cash-on-delivery.png'),
                icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 31,
                title: 'Penerimaan Stok',
                link: '/pengajuan/penerimaan/data',
                icon: require('@/assets/icon/cash-on-delivery.png'),
                icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 32,
                title: 'QC Barang',
                link: '/pengajuan/qc',
                icon: require('@/assets/icon/cash-on-delivery.png'),
                icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                active: false,
                sub_menu: [],
              }
            ],
          },
          {
            id: 44,
            title: 'Order',
            icon: require('@/assets/icon/order.png'),
            icon_color: require('@/assets/icon/order-color.png'),
            link: '/approval',
            active: false,
            sub_menu: [

            {
                        id: 300,
                        id: 45,
                        title: 'Tambah Order',
                        link: '/penjualan-counter',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
              {
                id: 45,
                title: 'Approval Order',
                link: '/approval/order',
                icon: require('@/assets/icon/order.png'),
                icon_color: require('@/assets/icon/order-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 46,
                title: 'Approval Order Warehouse',
                link: '/approval/order-warehouse',
                icon: require('@/assets/icon/order.png'),
                icon_color: require('@/assets/icon/order-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 88,
                title: 'Tracking Order',
                link: '/approval/order-tracking',
                icon: require('@/assets/icon/order.png'),
                icon_color: require('@/assets/icon/order-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 110,
                title: 'Audit Order',
                link: '/approval/order-audit',
                icon: require('@/assets/icon/order.png'),
                icon_color: require('@/assets/icon/order-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 48,
            title: 'Pengiriman ',
            icon: require('@/assets/icon/fast-delivery.png'),
            icon_color: require('@/assets/icon/fast-delivery-color.png'),
            link: '/delivery',
            active: false,
            sub_menu: [
              {
                id: 49,
                title: 'Buat BPB',
                link: '/delivery/bpb',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 50,
                title: 'Buat Surat Jalan',
                link: '/delivery/surat-jalan',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 77,
                title: 'Proses Muat',
                link: '/delivery/proses-muat',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 51,
                title: 'Konfirmasi Pengiriman',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                link: '/konfirmasi-pengirirman',
                active: false,
                sub_menu: [],
              },
              {
                id: 91,
                title: 'Reschedule BPB',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                link: '/delivery/reschedule',
                active: false,
                sub_menu: [],
              },
              {
                id: 58,
                title: 'Retur',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                link: '/retur',
                active: false,
                sub_menu: [], 
              },
            ],
          },
          {
            id: 52,
            title: 'Promo',
            icon: require('@/assets/icon/promo.png'),
            icon_color: require('@/assets/icon/promo-color.png'),
            link: '/promo',
            active: false,
            sub_menu: [
              {
                id: 53,
                title: 'Data Promo',
                link: '/promo/data',
                icon: require('@/assets/icon/promo.png'),
                icon_color: require('@/assets/icon/promo-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 54,
                title: 'Banner',
                link: '/promo/banner',
                icon: require('@/assets/icon/promo.png'),
                icon_color: require('@/assets/icon/promo-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 100,
                title: 'Strata Harga',
                link: '/promo/strata-harga',
                icon: require('@/assets/icon/promo.png'),
                icon_color: require('@/assets/icon/promo-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 33,
            title: 'Finance',
            icon: require('@/assets/icon/report.png'),
            icon_color: require('@/assets/icon/report-color.png'),
            link: '/finance',
            active: false,
            sub_menu: [
              {
                id: 34,
                title: 'Data Penerimaan Stok',
                link: '/finance/penerimaan/data',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 35,
                title: 'Close PO',
                link: '/finance/po/data',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 36,
                title: 'Invoice Supplier',
                link: '/finance/invoice-supplier',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 37,
                title: 'Invoice Customer',
                link: '/finance/invoice',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 82,
                title: 'Laporan Piutang',
                link: '/finance/laporan-faktur',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 38,
            title: 'Kasir',
            icon: require('@/assets/icon/cashier.png'),
            icon_color: require('@/assets/icon/cashier-color.png'),
            link: '/kasir',
            active: false,
            sub_menu: [
              {
                id: 39,
                title: 'Invoice Customer',
                link: '/kasir/customer',
                icon: require('@/assets/icon/cashier.png'),
                icon_color: require('@/assets/icon/cashier-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 200,
                title: 'Pengajuan Invoice',
                link: '/kasir/pengajuan-invoice',
                icon: require('@/assets/icon/cashier.png'),
                icon_color: require('@/assets/icon/cashier-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 201,
                title: 'Data Pembayaran',
                link: '/kasir/data-pembayaran',
                icon: require('@/assets/icon/cashier.png'),
                icon_color: require('@/assets/icon/cashier-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 40,
                title: 'Invoice Supplier',
                link: '/kasir/supplier',
                icon: require('@/assets/icon/cashier.png'),
                icon_color: require('@/assets/icon/cashier-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 92,
            title: 'Tanya Laporan AI',
            icon: require('@/assets/icon/ai.png'),
            icon_color: require('@/assets/icon/ai.png'),
            link: '/laporan-ai',
            active: false,
            sub_menu: [],
          },
          {
            id: 80,
            title: 'WA Gateway',
            icon: require('@/assets/icon/whatsapp.png'),
            icon_color: require('@/assets/icon/whatsapp-color.png'),
            link: '/wa-qr/data',
            active: false,
            sub_menu: [],
          },
          {
            id: 89,
            title: 'Log Activity',
            icon: require('@/assets/icon/activity-log.png'),
            icon_color: require('@/assets/icon/activity-log.png'),
            link: '/audit-trail',
            active: false,
            sub_menu: [],
          },
          {
            id: 101,
            title: 'Hapus Data',
            icon: require('@/assets/icon/delete-file.png'),
            icon_color: require('@/assets/icon/delete-file.png'),
            link: '/hapus-data',
            active: false,
            sub_menu: [
              // {
              //   id: 102,
              //   title: 'Data BPB',
              //   link: '/hapus-data/bpb',
              //   icon: require('@/assets/icon/delete-file.png'),
              //   icon_color: require('@/assets/icon/delete-file.png'),
              //   active: false,
              //   sub_menu: [],
              // },
              {
                id: 103,
                title: 'Data Surat Jalan',
                link: '/hapus-data/surat-jalan',
                icon: require('@/assets/icon/delete-file.png'),
                icon_color: require('@/assets/icon/delete-file.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
          {
            id: 55,
            title: 'Pengaturan',
            icon: require('@/assets/icon/settings-2.png'),
            icon_color: require('@/assets/icon/settings-color.png'),
            link: '/master',
            active: false,
            sub_menu: [
              {
                id: 5,
                title: 'Cabang',
                icon: require('@/assets/icon/settings-2.png'),
                icon_color: require('@/assets/icon/settings-color.png'),
                link: '/cabang',
                active: false,
                sub_menu: [],
              },
              {
                id: 47,
                title: 'Vehicle',
                icon: require('@/assets/icon/settings-2.png'),
                icon_color: require('@/assets/icon/settings-color.png'),
                link: '/vehicle/data',
                active: false,
                sub_menu: [],
              },
              {
                id: 56,
                title: 'Bank',
                link: '/master/bank',
                icon: require('@/assets/icon/settings-2.png'),
                icon_color: require('@/assets/icon/settings-color.png'),
                active: false,
                sub_menu: [],
              },
              {
                id: 57,
                title: 'Config',
                link: '/master/config',
                icon: require('@/assets/icon/settings-2.png'),
                icon_color: require('@/assets/icon/settings-color.png'),
                active: false,
                sub_menu: [],
              },
            ],
          },
        ]
      },
      async fetchMenu () {
        try {
          // Step 1: Get profile to get role (category_user_id)
          await get('admin/profile_user/detail')
          .then(async response => {
            let res = response.data
            
            if (res.status === 200) {
              const profile = res.results.data
              const categoryUserId = profile.category_user_id
              
              // Check if category_user_id = 1, use menu_default
              if (categoryUserId === 1 || categoryUserId === '1') {
                this.menu.left = this.getMenuDefault()
                this.$store.commit("setMenu", this.menu.left)
                TokenService.saveToken(
                  this.$store.state.token,
                  JSON.stringify(this.$store.state.user),
                  JSON.stringify(this.menu.left)
                )
                return
              }
              
              // Step 2: Get category_user data to get access rights (hak akses)
              if (categoryUserId) {
                let params = {
                  id: categoryUserId
                }
                
                await get('admin/category_user/data', { params })
                .then(response => {
                  let res = response.data
                  
                  if (res.status === 200 && res.results.data.length > 0) {
                    const categoryUser = res.results.data[0]
                    let menuArr = []
                    
                    // Parse menu_arr if exists and not empty
                    if (categoryUser.menu_arr && categoryUser.menu_arr.trim() !== '') {
                      try {
                        menuArr = JSON.parse(categoryUser.menu_arr)
                      } catch (e) {
                        console.error('Error parsing menu_arr:', e)
                        menuArr = []
                      }
                    }
                    
                    // If menu_arr is empty or null, use menu_default
                    if (!menuArr || menuArr.length === 0) {
                      this.menu.left = this.getMenuDefault()
                    } else {
                      this.menu.left = menuArr
                    }
                    
                    // Update store and localStorage
                    this.$store.commit("setMenu", this.menu.left)
                    TokenService.saveToken(
                      this.$store.state.token,
                      JSON.stringify(this.$store.state.user),
                      JSON.stringify(this.menu.left)
                    )
                  } else {
                    // Fallback to menu_default if API fails
                    this.menu.left = this.getMenuDefault()
                    this.$store.commit("setMenu", this.menu.left)
                    TokenService.saveToken(
                      this.$store.state.token,
                      JSON.stringify(this.$store.state.user),
                      JSON.stringify(this.menu.left)
                    )
                  }
                })
                .catch(error => {
                  console.error('Error fetching category_user data:', error)
                  // Fallback to menu_default on error
                  this.menu.left = this.getMenuDefault()
                  this.$store.commit("setMenu", this.menu.left)
                  TokenService.saveToken(
                    this.$store.state.token,
                    JSON.stringify(this.$store.state.user),
                    JSON.stringify(this.menu.left)
                  )
                })
              } else {
                // Fallback to menu_default if no category_user_id
                this.menu.left = this.getMenuDefault()
                this.$store.commit("setMenu", this.menu.left)
                TokenService.saveToken(
                  this.$store.state.token,
                  JSON.stringify(this.$store.state.user),
                  JSON.stringify(this.menu.left)
                )
              }
            } else {
              // Fallback to menu_default if profile fetch fails
              this.menu.left = this.getMenuDefault()
              this.$store.commit("setMenu", this.menu.left)
              TokenService.saveToken(
                this.$store.state.token,
                JSON.stringify(this.$store.state.user),
                JSON.stringify(this.menu.left)
              )
            }
          })
          .catch(error => {
            console.error('Error fetching profile:', error)
            // Fallback to menu_default on error
            this.menu.left = this.getMenuDefault()
            this.$store.commit("setMenu", this.menu.left)
            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(this.$store.state.user),
              JSON.stringify(this.menu.left)
            )
          })
        } catch (error) {
          console.error('Error in fetchMenu:', error)
          // Fallback to menu_default on error
          this.menu.left = this.getMenuDefault()
          this.$store.commit("setMenu", this.menu.left)
          TokenService.saveToken(
            this.$store.state.token,
            JSON.stringify(this.$store.state.user),
            JSON.stringify(this.menu.left)
          )
        }
      },
      async fetchConfig () {
        this.process.load = true

        let params = {
          // company_id: this.user.company_id
        }

        await get('admin/config', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])

            // if (res.results.data[0].color.length > 0) {
            //   res.results.data[0].color.map((obj) => {
            //     if (obj.active) {
            //       TokenService.saveColor(obj.hex)

            //       this.$store.commit("setColor", obj.hex)
            //     }
            //   })
            // } else {
            //   TokenService.saveColor('#DD5826')

            //   this.$store.commit("setColor", '#DD5826')
            // }

            // this.styles()
          }
        })
      },
      sortMenuDashboardFirst () {
        // Cari index menu Dashboard atau id 122
        const dashboardIndex = this.menu.left.findIndex(item => 
          item.title === 'Dashboard' || item.id === 122
        )
        
        // Jika ditemukan dan bukan di posisi pertama, pindahkan ke atas
        if (dashboardIndex > 0) {
          const dashboardMenu = this.menu.left.splice(dashboardIndex, 1)[0]
          this.menu.left.unshift(dashboardMenu)
        }
      },
      restartFilter () {
        this.$store.commit("setCustomer", {}) 
      },
      restartFilterOrder () {
        this.$store.commit("setOrder", {}) 
      },
      async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }


          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 13px;
  }
</style>